import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=2e6131b3&scoped=true&"
import script from "./InputBox.vue?vue&type=script&lang=js&"
export * from "./InputBox.vue?vue&type=script&lang=js&"
import style0 from "./InputBox.vue?vue&type=style&index=0&id=2e6131b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6131b3",
  null
  
)

export default component.exports